import { useMemo } from 'react'
import { Column } from 'react-table'
import Table from '../../../global/components/table/Table'
import DeleteButton from '../../../global/components/buttons/delete-button/DeleteButton'
import SecondaryButton from '../../../global/components/buttons/secondary-button/SecondaryButton'

export interface CategoryListItem {
  objectId: string
  name: string
  description: string | null
  examples: string[] | null
}

interface CategoryTableProps {
  categories: CategoryListItem[]
  isLoading: boolean
  onEdit: (category: CategoryListItem) => void
  onDelete: (objectId: string) => void
}

function CategoryTable({ categories, isLoading, onEdit, onDelete }: CategoryTableProps) {
  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Description',
        Cell: ({ row }: any) => row.original.description || '-',
      },
      {
        Header: 'Examples',
        Cell: ({ row }: any) =>
          row.original.examples?.length ? row.original.examples.length : '-',
      },
      {
        Header: 'Actions',
        Cell: ({ row }: any) => (
          <div style={{ display: 'flex', gap: '8px' }}>
            <SecondaryButton
              buttonName='Edit'
              onClick={(e) => {
                e.stopPropagation()
                onEdit(row.original)
              }}
            />
            <DeleteButton
              buttonName='Delete'
              onClick={(e) => {
                e.stopPropagation()
                onDelete(row.original.objectId)
              }}
            />
          </div>
        ),
      },
    ],
    [onEdit, onDelete],
  )

  return (
    <Table
      columns={columns}
      data={categories}
      isLoading={isLoading}
      isDisplayMode={true}
      noDataMessage='No categories added yet.'
    />
  )
}

export default CategoryTable
